module.exports = __webpack_public_path__ + "static/media/bottom_infographic_desktop.b06c8a42.webp";